@if (variant === "count") {
    @if (count) {
        <span class="indicator indicator-count">{{ count }}</span>
    }
}
@else if (variant === "required") {
    <span class="indicator indicator-required" aria-hidden="true">*</span>
}
